module.exports = __webpack_public_path__ + "img/SVG4_FinancialCommitments.167d566e.svg";